module.exports = __webpack_public_path__ + "media/images/smart-admin-bff36c1caf68f70d80aaec02f561bc24.png";